import { parseNumberArg } from '@/utils/string'

import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: 'merchant/list',
    name: 'merchant-list',
    meta: { title: '商户列表', componentName: 'MerchantList' },
    component: () => import('@/views/pc/seller/MerchantList.vue'),
    props: true
  },
  {
    path: 'merchant/:merchantId(\\d+)',
    name: 'merchant-info',
    meta: { title: '商户信息', componentName: 'MerchantInfo' },
    component: () => import('@/views/pc/seller/MerchantInfo.vue'),
    props: (to) => ({ merchantId: parseNumberArg(to.params.merchantId) })
  },
  {
    path: 'product/list',
    name: 'product-list',
    meta: { title: '商品列表', componentName: 'ProductList' },
    component: () => import('@/views/pc/seller/ProductList.vue'),
    props: () => ({ sellerId: 0 })
  },
  {
    path: 'product/:sellerId(\\d+)/list',
    name: 'seller-product-list',
    meta: { title: '商品列表', componentName: 'ProductList' },
    component: () => import('@/views/pc/seller/ProductList.vue'),
    props: (to) => ({ sellerId: parseNumberArg(to.params.sellerId) })
  },
  {
    path: 'product/:productId(\\d+)',
    name: 'product-info',
    meta: { title: '商品信息', componentName: 'ProductInfo' },
    component: () => import('@/views/pc/seller/ProductInfo.vue'),
    props: (to) => ({ productId: parseNumberArg(to.params.productId), sellerId: parseNumberArg(to.query.sellerId) })
  },
  {
    path: 'sku/list',
    name: 'sku-list',
    meta: { title: '规格列表', componentName: 'SkuList' },
    component: () => import('@/views/pc/seller/SkuList.vue'),
    props: true
  },
  {
    path: 'sku/:productId(\\d+)/list',
    name: 'product-sku-list',
    meta: { title: '商品规格列表', componentName: 'SkuList' },
    component: () => import('@/views/pc/seller/SkuList.vue'),
    props: (to) => ({ productId: parseNumberArg(to.params.productId) })
  },
  {
    path: 'sku/:skuId(\\d+)',
    name: 'sku-info',
    meta: { title: '规格信息', componentName: 'SkuInfo' },
    component: () => import('@/views/pc/seller/SkuInfo.vue'),
    props: (to) => ({ skuId: parseNumberArg(to.params.skuId), productId: parseNumberArg(to.query.productId) })
  }
] as RouteRecordRaw[]
